/**
 * /p/mock-usd — Página estática con datos mock en USD
 *
 * Simula la respuesta de GET /api/products/by-slug?slug=mock-usd&country=US
 * Producto solo USD. Checkout → Stripe.
 */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { mockProductStaticUsd } from '@/mocks/productBySlug';

const product = mockProductStaticUsd;

export default function ProductPageMockUsd() {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = product.page_title || product.name;
  }, []);

  const handlePagar = () => {
    alert(`[MOCK USD] Pasarela: Stripe\nPrecio: ${product.recommended_currency} ${product.recommended_price}\nEn producción se abriría el custom checkout de Stripe.`);
  };

  return (
    <>
      <div className="fixed top-0 left-0 right-0 z-50 bg-blue-500/90 text-white text-center py-1 text-sm font-medium">
        🧪 Mock USD — Checkout Stripe
      </div>
      <div className="min-h-screen bg-black py-12 px-4 pt-14">
        <article className="max-w-lg mx-auto">
          {(product.hero_image_url || product.image_url) && (
            <div className="rounded-xl overflow-hidden mb-6 bg-white/10 aspect-video">
              <img
                src={product.hero_image_url || product.image_url}
                alt={product.image_alt || product.name}
                className="w-full h-full object-cover"
              />
            </div>
          )}
          <h1 className="text-2xl font-semibold text-white mb-2">{product.name}</h1>
          <p className="text-white/60 mb-6 whitespace-pre-wrap">{product.page_description || product.description}</p>
          <div className="flex items-baseline gap-2 mb-6">
            <span className="text-3xl font-bold text-white">
              {product.recommended_currency} {product.recommended_price}
            </span>
          </div>
          <Button
            size="lg"
            className="w-full bg-white text-black font-semibold hover:bg-white/90"
            onClick={handlePagar}
          >
            {product.cta_button_text || 'Comprar'}
          </Button>
          <Button
            variant="ghost"
            className="w-full mt-3 text-white/60 hover:text-white hover:bg-white/10"
            onClick={() => navigate('/')}
          >
            Volver al inicio
          </Button>
        </article>
      </div>
    </>
  );
}
